// 이행매장 선택 병합
// 기존 선택(base)에 추가 목록(insert)을 중복 없이 누적하고, 삭제 목록(remove)을 제거한 매장코드 배열을 반환한다.
// 순서는 base → insert 첫 등장 순서를 유지한다.
// base 내부 중복도 함께 제거한다(insert 만 검사하던 이전 onConfirm 과의 의도된 차이). 서버 stores 에 중복 코드가 섞여 와도 목록·카운트를 정합하게 맞추기 위함.
// 그룹 채널 적용(onConfirm)과 엑셀 업로드 반영(handleApplyExcelStores)이 함께 사용한다.
// 엑셀은 최대 5,000행까지 들어올 수 있어 includes 기반 O(n·m) 대신 Set 으로 O(n+m) 처리한다.
export default function mergeStoreIds(base: string[], insert: string[], remove: string[]): string[] {
  const removeSet = new Set(remove);
  const seen = new Set<string>();
  const result: string[] = [];

  [...base, ...insert].forEach((storeId) => {
    if (removeSet.has(storeId) || seen.has(storeId)) return;
    seen.add(storeId);
    result.push(storeId);
  });

  return result;
}
